module.exports = __webpack_public_path__ + "img/product-poster.22111e50.jpg";